<template>
  <div class="payment-method">
    <a
      href="#!"
      class="payment-btn"
      :class="{
        selected:
          selectedPaymentMethod &&
          selectedPaymentMethod.id === paymentMethod.id,
        recommended: paymentMethod.group === 'recommended',
      }"
      @click="setPaymentMethod(paymentMethod)"
    >
      <h5 class="action">
        {{ mainLabel }}
      </h5>
      <div class="payment-method-img-container">
        <img
          class="payment-method-img"
          :src="paymentMethod.image_url"
          :alt="paymentMethod.name"
        />
      </div>
      <!-- <div
        class="payment-method-img"
        :style="{ backgroundImage: `url('${paymentMethod.image_url}')` }"
      ></div> -->
      <!-- <h5 class="name">{{ paymentMethod.name }}</h5> -->

      <!-- <h5 class="payment-method-type-img">{{ paymentMethod.name }}</h5> -->

      <!-- <img class="payment-method-type-img" :src="mainImage" /> -->
    </a>
  </div>
</template>
<script>
export default {
  name: "PaymentMethodCardOption",
  props: {
    paymentMethod: {},
    selectedPaymentMethod: {},
  },
  methods: {
    setPaymentMethod(paymentMethod) {
      this.$emit("click", paymentMethod);
    },
  },
  computed: {
    payType() {
      if (this.paymentMethod.name === "NowPayments") {
        return "crypto";
      }
      
      if (this.paymentMethod.name === "Yape") {
        return "virtual_wallet";
      }

      return "card";
    },
    mainLabel() {
      if (this.payType === "crypto") {
        return this.$t("payment_method.extra.crypto");
      }
      
      if (this.payType === "virtual_wallet") {
        return this.$t("payment_method.extra.virtual_wallet");
      }
      
      return (
        this.$t("payment_method.extra.credit") +
        " / " +
        this.$t("payment_method.extra.debit")
      );
    },
    mainImage() {
      if (this.payType === "crypto") {
        return "/img/payment_methods/crypto.png";
      }
      
      if (this.payType === "virtual_wallet") {
        return "/img/payment_methods/virtual_wallet.png";
      }

      return "/img/payment_methods/visa_master.png";
    },
  },
};
</script>
<style scoped lang="scss">
@import "./../styles/variables";
@import "./../styles/classes";

.payment-method {
  text-align: center;
  width: auto;

  .payment-btn {
    display: flex;
    flex-direction: column;
    min-width: 120px;
    margin: 0.5em 0;
    padding: 0.5em;
    border-radius: 5px;
    height: 150px;
    // @extend %fresh-btn;

    .payment-method-img-container {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 40px;
      margin-block: 0.5em;
    }

    .action {
      padding-top: 0.25em;
      font-size: 1em;
      color: var(--pallete_clear_text_color);
      margin: 0 0 0.5em 0;
    }

    .payment-method-img {
      display: block;
      margin-left: auto;
      margin-right: auto;
      transition: filter 0.5s;
      width: 100px;
      //box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.25);
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
    }

    .payment-method-type-img {
      display: block;
      margin: auto auto 0.5em auto;
      transition: filter 0.5s;
      // width: 75px;
      background-color: var(--pallete_clear_color);
      filter: grayscale(100%);
      padding-inline: 1em;
    }

    .name {
      margin: 0.5em 0 0 0;
    }

    &.selected {
      background-color: var(--pallete_main_color);
      opacity: 0.85;

      .payment-method-img {
        filter: grayscale(0%);
      }

      .action {
        color: var(--pallete_clear_color);
      }
    }

    &.recommended {
      .payment-method-img {
        width: 150px;
      }

      .action {
        font-size: 1em;
        font-weight: normal;
        color: black;
      }

      .name {
        font-size: 1.3em;
      }

      .payment-btn {
        min-width: 120px;
        margin: 0.5em 0;
        padding: 0.5em;
        border-radius: 50px;
      }

      &.selected  {
        .action {
          color: white;
        }
      }
    }
  }
}
</style>
